var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4L11.5995 13.1069C11.5434 13.8918 10.8903 14.5 10.1033 14.5H3.89668C3.10972 14.5 2.45656 13.8918 2.40049 13.1069L1.75 4M5.5 7V11.5M8.5 7V11.5M9.25 4V1.75C9.25 1.33579 8.91421 1 8.5 1H5.5C5.08579 1 4.75 1.33579 4.75 1.75V4M1 4H13",
    stroke: "#BE3740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconMenu);
export default __webpack_public_path__ + "static/media/delete-icon-menu.2764533e39a1de7dcefabe93b084ef93.svg";
export { ForwardRef as ReactComponent };